var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useRef, useCallback, useEffect } from 'react'; // 导入 useCallback
import { useTranslation } from 'react-i18next'; // 导入 useTranslation
import { Radio, Card, Modal } from 'antd';
import { Input, Form } from 'antd';
import DataTable from './DataTable'; // 导入 DataTable 组件和 DataType 接口
import Header from './Header';
import StatsDisplay from './StatsDisplay'; // 导入 StatsDisplay 组件
import api from '@/api'; // 导入 API 模块
const MainControls = () => {
    const { t } = useTranslation(); // 调用 useTranslation Hook
    const [competitionType, setCompetitionType] = useState(localStorage.getItem('mainControls_competitionType') || '');
    const [projectTech, setProjectTech] = useState(localStorage.getItem('mainControls_projectTech') || 'W_SOLO_TECH');
    const INITIAL_DATA_SOURCE = [
        { key: '1', time: '', part: '', index: 1, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '2', time: '', part: '', index: 2, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '3', time: '', part: '', index: 3, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '4', time: '', part: '', index: 4, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '5', time: '', part: '', index: 5, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '6', time: '', part: '', index: 6, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '7', time: '', part: '', index: 7, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '8', time: '', part: '', index: 8, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '9', time: '', part: '', index: 9, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '10', time: '', part: '', index: 10, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '11', time: '', part: '', index: 11, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '12', time: '', part: '', index: 12, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '13', time: '', part: '', index: 13, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '14', time: '', part: '', index: 14, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '15', time: '', part: '', index: 15, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '16', time: '', part: '', index: 16, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '17', time: '', part: '', index: 17, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '18', time: '', part: '', index: 18, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '19', time: '', part: '', index: 19, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '20', time: '', part: '', index: 20, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '21', time: '', part: '', index: 21, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '22', time: '', part: '', index: 22, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '23', time: '', part: '', index: 23, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '24', time: '', part: '', index: 24, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
        { key: '25', time: '', part: '', index: 25, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    ];
    const [theme, setTheme] = useState(() => localStorage.getItem('mainControls_theme') || '');
    const [athleteName, setAthleteName] = useState(() => localStorage.getItem('mainControls_athleteName') || '');
    const [organization, setOrganization] = useState(() => localStorage.getItem('mainControls_organization') || '');
    const [competitionName, setCompetitionName] = useState(() => localStorage.getItem('mainControls_competitionName') || '');
    const [dataTableData, setDataTableData] = useState([]);
    useEffect(() => {
        localStorage.setItem('mainControls_competitionType', competitionType);
    }, [competitionType]);
    useEffect(() => {
        localStorage.setItem('mainControls_projectTech', projectTech);
    }, [projectTech]);
    useEffect(() => {
        localStorage.setItem('mainControls_theme', theme);
    }, [theme]);
    useEffect(() => {
        localStorage.setItem('mainControls_athleteName', athleteName);
    }, [athleteName]);
    useEffect(() => {
        localStorage.setItem('mainControls_organization', organization);
    }, [organization]);
    useEffect(() => {
        localStorage.setItem('mainControls_competitionName', competitionName);
    }, [competitionName]);
    // 辅助函数：计算 tc 值和状态
    const calculateTcAndStatus = (row) => __awaiter(void 0, void 0, void 0, function* () {
        let newTc = 0;
        let tcStatus = undefined;
        try {
            const res = yield api.CoachCardApi.getScoresByCodes({
                base_mark: row.baseScore || '',
                declared_difficulty_code: row.declaredDifficulty || '',
                bonus_code: row.bonus || '',
                part: row.part || '',
                eventphase_type1: projectTech.substring(2) || '',
            });
            if (res.data && res.data.code === 200) {
                const totalScore = parseFloat(res.data.data.base_mark_score || '0') +
                    parseFloat(res.data.data.declared_difficulty_score || '0') +
                    parseFloat(res.data.data.bonus_score || '0');
                newTc = parseFloat(totalScore.toFixed(4));
            }
            if (newTc !== parseFloat(row.difficultyValue || '0')) {
                tcStatus = 'invalid';
            }
            else {
                tcStatus = 'valid';
            }
        }
        catch (error) {
            newTc = parseFloat(row.tc || '0');
            tcStatus = 'invalid';
        }
        return Object.assign(Object.assign({}, row), { tc: newTc, index: row.index, tcStatus: tcStatus });
    });
    // 重置 MainControls 中的所有字段
    const resetMainControlsFields = useCallback(() => {
        setCompetitionType('');
        setProjectTech('');
        setTheme('');
        setAthleteName('');
        setOrganization('');
        setCompetitionName('');
    }, []);
    // 在组件挂载时从 localStorage 加载数据
    useEffect(() => {
        const savedOrganization = localStorage.getItem('mainControls_organization');
        if (savedOrganization) {
            setOrganization(savedOrganization);
        }
        const savedCompetitionName = localStorage.getItem('mainControls_competitionName');
        if (savedCompetitionName)
            setCompetitionName(savedCompetitionName);
        const savedCompetitionType = localStorage.getItem('mainControls_competitionType');
        if (savedCompetitionType)
            setCompetitionType(savedCompetitionType);
        const savedProjectTech = localStorage.getItem('mainControls_projectTech');
        if (savedProjectTech) {
            setProjectTech(savedProjectTech);
        }
        const savedTheme = localStorage.getItem('mainControls_theme');
        if (savedTheme)
            setTheme(savedTheme);
        const savedAthleteName = localStorage.getItem('mainControls_athleteName');
        if (savedAthleteName)
            setAthleteName(savedAthleteName);
        const savedDataTableData = localStorage.getItem('mainControls_dataTableData');
        if (savedDataTableData) {
            try {
                const parsedData = JSON.parse(savedDataTableData);
                setDataTableData(parsedData);
            }
            catch (error) {
            }
        }
        else {
            //重置
            setDataTableData(INITIAL_DATA_SOURCE);
        }
    }, []);
    const dataTableResetFunc = useRef(null); // 创建 ref
    // 用于清除 DataTable 数据的函数
    const clearAllDataTableData = useCallback(() => {
        if (dataTableResetFunc.current) {
            dataTableResetFunc.current(); // 清空 DataTable 数据
        }
        resetMainControlsFields(); // 清空 MainControls 字段
    }, [resetMainControlsFields]);
    const setDataTableResetFunc = useCallback((func) => {
        dataTableResetFunc.current = func;
    }, []);
    const handleCompetitionTypeChange = (e) => {
        setCompetitionType(e.target.value);
    };
    const handleProjectTechChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        //当有值的时候
        if (projectTech) {
            //弹框提示
            Modal.confirm({
                title: '',
                content: t('modal.confirm_clear_card_info'),
                onOk() {
                    setProjectTech(e.target.value);
                    //清空表格数据
                    setDataTableData(INITIAL_DATA_SOURCE);
                },
                onCancel() {
                    setProjectTech(e.target.value);
                },
            });
            return;
        }
        //没有值的时候
        setProjectTech(e.target.value);
    });
    const handleDataTableChange = useCallback((newDataSource) => __awaiter(void 0, void 0, void 0, function* () {
        const updatedDataSourcePromises = newDataSource;
        const updatedDataSource = updatedDataSourcePromises;
        setDataTableData(updatedDataSource);
        localStorage.setItem('mainControls_dataTableData', JSON.stringify(updatedDataSource));
    }), [calculateTcAndStatus]);
    const handleImportSuccess = useCallback((importedData) => __awaiter(void 0, void 0, void 0, function* () {
        // 导入成功后，更新 DataTable 的数据
        const formattedData = importedData.map((item, index) => ({
            key: (index + 1).toString(),
            time: item.time || '',
            part: item.part || '',
            index: item.el,
            baseScore: item.base_mark_name || '',
            declaredDifficulty: item.declared_difficulty || '',
            bonus: item.bonus || '',
            difficultyValue: item.difficulty_degree || '',
            tc: item.tc || '',
            // 为 DataType 中其他缺失的 selected... 属性设置默认值
            selectedGroup: null,
            selectedDeclaredDifficulty: null,
            selectedBonus: null,
            selectedDifficultyValue: null,
            selectedContent: null,
            selectedDeclaredDifficultyHybrid: null,
            selectedDeclaredDifficultyAcroDuet: null,
        }));
        let finalDataSource = formattedData;
        if (finalDataSource.length < 25) {
            const remainingCount = 25 - finalDataSource.length;
            const emptyRowsToPad = INITIAL_DATA_SOURCE.slice(0, remainingCount).map((row, idx) => (Object.assign(Object.assign({}, row), { key: (finalDataSource.length + idx + 1).toString(), index: '' // finalDataSource.length + idx + 1,
             })));
            finalDataSource = [...finalDataSource, ...emptyRowsToPad];
        }
        const updatedDataSourcePromises = finalDataSource.map(row => calculateTcAndStatus(row));
        const updatedDataSource = yield Promise.all(updatedDataSourcePromises);
        setDataTableData(updatedDataSource);
        localStorage.setItem('mainControls_dataTableData', JSON.stringify(updatedDataSource));
    }), [calculateTcAndStatus]);
    return (<div style={{ background: '#f9f9f9' }}>
      <Header onClearAll={clearAllDataTableData} onImportSuccess={handleImportSuccess} competitionType={competitionType} projectTech={projectTech} theme={theme} athleteName={athleteName} organization={organization} competitionName={competitionName} dataTableData={dataTableData}/>
      <div style={{ padding: '25px 20px', background: '#f9f9f9', gap: 10 }}>
        <Form layout="horizontal" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
          <Form.Item label={t('main_controls.organization')} style={{ marginBottom: 8 }}>
            <Input value={organization} onChange={(e) => {
            setOrganization(e.target.value);
        }}/>
          </Form.Item>
          <Form.Item label={t('main_controls.competition')} style={{ marginBottom: 8 }}>
            <Input value={competitionName} onChange={(e) => setCompetitionName(e.target.value)}/>
          </Form.Item>
          {/* Competition Phase Selection */}
          <Form.Item label={t('main_controls.competition_phase')} style={{ marginBottom: 8 }}>
            <Card>
              <Radio.Group onChange={handleCompetitionTypeChange} value={competitionType}>
                <Radio value="final">{t('main_controls.final')}</Radio>
                <Radio value="preliminary">{t('main_controls.preliminary')}</Radio>
              </Radio.Group>
            </Card>
          </Form.Item>
          {/* Project Selection */}
          <Form.Item label={t('main_controls.event')} style={{ marginBottom: 8 }}>
            <Card>
              <Radio.Group onChange={handleProjectTechChange} value={projectTech}>
                <Radio value="W_SOLO_TECH">{t('main_controls.solo_tech_female')}</Radio>
                <Radio value="M_SOLO_TECH">{t('main_controls.solo_tech_male')}</Radio>
                <Radio value="-_DUET_TECH">{t('main_controls.duet_tech')}</Radio>
                <Radio value="X_MIXED_DUET_TECH">{t('main_controls.mixed_duet_tech')}</Radio>
                <Radio value="-_TEAM_TECH">{t('main_controls.team_tech')}</Radio>
                <Radio value="-_ACROBATIC">{t('main_controls.acrobatic')}</Radio>
                <Radio value="W_SOLO_FREE">{t('main_controls.solo_free_female')}</Radio>
                <Radio value="M_SOLO_FREE">{t('main_controls.solo_free_male')}</Radio>
                <Radio value="-_DUET_FREE">{t('main_controls.duet_free')}</Radio>
                <Radio value="X_MIXED_DUET_FREE">{t('main_controls.mixed_duet_free')}</Radio>
                <Radio value="-_TEAM_FREE">{t('main_controls.team_free')}</Radio>
                <Radio value="-_FREE_COMBINATION">{t('main_controls.free_combination')}</Radio>
              </Radio.Group>
            </Card>
          </Form.Item>
          <Form.Item label={t('main_controls.theme')} style={{ marginBottom: 8 }}>
            <Input value={theme} onChange={(e) => setTheme(e.target.value)}/>
          </Form.Item>
          <Form.Item label={t('main_controls.athlete_name')} style={{ marginBottom: 8 }}>
            <Input value={athleteName} placeholder={t('main_controls.enter_multiple_athletes_separated_by_comma')} onChange={(e) => setAthleteName(e.target.value)}/>
          </Form.Item>
        </Form>
        <DataTable projectTech={projectTech} onClearAll={setDataTableResetFunc} // 传递给 DataTable
     onDataSourceChange={handleDataTableChange} // 传递 handleDataTableChange
     dataTableData={dataTableData} //把导入的excel表的值传给dataTable组件
    />
        <StatsDisplay dataSource={dataTableData} projectTech={projectTech}/> {/* 传递 dataTableData 给 StatsDisplay */}
      </div>
    </div>);
};
export default MainControls;
